// 普通用户用户中心相关接口
import request from '../utils/axios'


/* 加工厂/集材厂相关*/
// 获取自己的加工厂/集材场列表
export function GetFactoryLis(params) {
  return request({
    url: '/User/GetUserFacList',
    method: 'post',
		data:params
  })
}

// 获取加工厂/集材场申请详情(普通用户)
export function GetFacDetail(id) {
  return request({
    url: `/Examine/GetFacDetail2?id=${id}`,
    method: 'get'
  })
}

/* 采伐者相关*/
// 获取我的列表（普通用户）
export function GetExamineLis() {
  return request({
    url: '/Examine/GetFellMyLis',
    method: 'get'
  })
}

// 获取审批详情
export function GetExamineDetails(id) {
  return request({
		url: `/Examine/GetFellDetail2?id=${id}`,
    method: 'get'
  })
}